import { Button, Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { BLUE_COLOR } from '../../../../constants/ColorsConst';
import { LoadingWidget, ModalComponent } from '../../../../widgets';
import { PARAMS_NOTAS_BLOPED } from '../NotasBlopedReducer';
import TableEstudiantesNotasComponent from './TableEstudiantesNotas';

const ListadoEstudiantesNotasBloped = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const notasBlopedStore = Redux.useSelector((state) => state.notasBloped);

  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const payload = {
      ...notasBlopedStore.params,
      idEntidad: entidadesStore.activo.id,
      idPeriodoAcademico: entidadesStore.ajustes.periodoAcademico.id,
      idDocente: loginStore.isTeacher ? docentesStore.activo.id : null,
    };
    dispatch({
      type: PARAMS_NOTAS_BLOPED,
      payload,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    notasBlopedStore.planEvaluacion && (
      <Grid container>
        <LoadingWidget isLoading={notasBlopedStore.loadingAll} />
        <Grid item md={12}>
          {notasBlopedStore.params.idSeccion &&
          notasBlopedStore.all.length !== 0 ? (
            <TableEstudiantesNotasComponent />
          ) : null}
        </Grid>
        {notasBlopedStore.activo && (
          <ModalComponent
            id="modalDeleteNotasBloped"
            title={`Eliminar`}
            open={openModalDelete}
            maxWidth="sm"
            onClose={() => setOpenModalDelete(!openModalDelete)}
          >
            <Grid container spacing={1}>
              <Grid item md={12}>
                ¿Seguro que quieres eliminar esta sección?
                <Typography variant="h6">
                  Sección {notasBlopedStore.activo.nombre} de{' '}
                  {notasBlopedStore.activo.nivelAcademico.nivelAcademico.nombre}
                </Typography>
              </Grid>
              <Grid item md={12} align="right">
                <Button
                  color="error"
                  variant="outlined"
                  onClick={async () => {
                    // await _handleDeleteClick(notasBlopedStore.activo.id);
                  }}
                  sx={{ mr: 2 }}
                >
                  ELIMINAR
                </Button>
                <Button
                  sx={{ color: BLUE_COLOR }}
                  onClick={() => setOpenModalDelete(false)}
                >
                  CANCELAR
                </Button>
              </Grid>
            </Grid>
          </ModalComponent>
        )}
      </Grid>
    )
  );
};

export default ListadoEstudiantesNotasBloped;
